export const inputTheme = {
  variants: {
    primaryOutline: {
      field: {
        _focus: {
          borderColor: 'primaryColor',
        },
      },
    },
  },
};
